import React, { useMemo, useState } from 'react';
import { Store } from 'lucide-react';
import SignedImage from '@/components/ipe/SignedImage';

const DEFAULT_LABEL = 'TikTok';

/**
 * TikTok 店铺头像：有自定义图则展示图片，否则默认显示 TikTok 名称。
 */
export default function TiktokShopAvatar({
  avatarUrl = '',
  size = 28,
  className = '',
  emptyIcon = false,
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const raw = String(avatarUrl || '').trim();
  const fontSize = useMemo(() => {
    if (size >= 64) return Math.round(size * 0.22);
    if (size >= 40) return Math.round(size * 0.26);
    return Math.max(8, Math.round(size * 0.32));
  }, [size]);

  const fallback = emptyIcon ? (
    <span
      className={`tiktok-shop-avatar tiktok-shop-avatar--empty${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <Store size={Math.round(size * 0.5)} strokeWidth={2} />
    </span>
  ) : (
    <span
      className={`tiktok-shop-avatar tiktok-shop-avatar--default${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size, fontSize }}
      aria-hidden="true"
    >
      {DEFAULT_LABEL}
    </span>
  );

  if (!raw || imageFailed) {
    return fallback;
  }

  return (
    <SignedImage
      url={raw}
      alt=""
      className={`tiktok-shop-avatar tiktok-shop-avatar--image${className ? ` ${className}` : ''}`}
      style={{ width: size, height: size }}
      loading="eager"
      loadingFallback={fallback}
      fallback={fallback}
      onError={() => setImageFailed(true)}
      aria-hidden="true"
    />
  );
}
